exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fix-chip-2{width:150px}.fix-chip-2 .v-chip__content{text-align:center;margin:auto}\n", ""]);
